module.exports = __webpack_public_path__ + "static/media/hradmin.0ead5646.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hradmin.svg
// module id = 2194
// module chunks = 0